import { render, staticRenderFns } from "./HonorsEdit.vue?vue&type=template&id=3da7e237&scoped=true&"
import script from "./HonorsEdit.vue?vue&type=script&lang=js&"
export * from "./HonorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7e237",
  null
  
)

export default component.exports